import React from 'react';
import Icon from '../../../components/AppIcon';

const FinancialSummaryCard = ({ title, amount, change, changeType, icon, iconBg }) => {
  const formatAmount = (value) => {
    // Ensure value is a number
    const numericValue = typeof value === 'string' ? parseFloat(value?.replace(/[^0-9.-]+/g, '')) : parseFloat(value);
    
    // Check if conversion resulted in a valid number
    if (isNaN(numericValue)) {
      return 'DZD0.00';
    }
    
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'DZD',
      minimumFractionDigits: 2
    })?.format(numericValue);
  };

  return (
    <div className="bg-card rounded-lg p-6 border border-border shadow-card hover:shadow-interactive transition-shadow duration-200">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm text-muted-foreground font-medium mb-2">{title}</p>
          <p className="text-3xl font-semibold text-foreground mb-3">{formatAmount(amount)}</p>
          {change !== undefined && (
            <div className="flex items-center gap-2">
              <Icon 
                name={changeType === 'increase' ? 'TrendingUp' : 'TrendingDown'} 
                size={16} 
                color={changeType === 'increase' ? 'var(--color-success)' : 'var(--color-error)'}
              />
              <span className={`text-sm font-medium ${changeType === 'increase' ? 'text-success' : 'text-error'}`}>
                {typeof change === 'number' ? `${Math.abs(change)}%` : change}
              </span>
              {typeof change === 'number' && (
                <span className="text-xs text-muted-foreground">vs mois dernier</span>
              )}
            </div>
          )}
        </div>
        <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${iconBg}`}>
          <Icon name={icon} size={24} color="#FFFFFF" />
        </div>
      </div>
    </div>
  );
};

export default FinancialSummaryCard;